import { httpClient } from "./httpClient";

const base = "/api/modulos-sistema";

// Retorna array: [{ clave, nombre, descripcion, habilitado, fecha_expiracion }]
export const listar = () => httpClient.get(base);

export const actualizar = (clave, datos) => httpClient.put(`${base}/${clave}`, datos);

const modulosSistemaService = { listar, actualizar };
export default modulosSistemaService;
